import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';

@Component({
  selector: 'sh-not-found',
  templateUrl: './not-found.component.html',
  standalone: true,
})
export class NotFoundComponent implements OnInit {
  errorMessage?: string;
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.data.subscribe((data: Data) => {
      this.errorMessage = data['message'];
    });
  }
}
